// wont work for unicode
const jwtDecode = (token) => {
  if (token == null || token === 'undefined' || token === '') return null
  try {
    return JSON.parse(atob(token.split('.')[1]))
  } catch (e) {
    console.log('error parsing token')
  }
  return null
}

export default jwtDecode
